import { useEffect } from 'react';
import { useTour } from './TourContext';

/**
 * Drop this hook into any page component.
 * Opens the feature guide automatically on first visit to that page.
 * Does nothing for users who have already seen or dismissed it.
 *
 * Usage:
 *   import useAutoTour from '../tours/useAutoTour';
 *   useAutoTour('crm');
 */
export default function useAutoTour(tourId, delayMs = 800) {
  const { openGuide, hasSeenTour, loaded } = useTour();

  useEffect(() => {
    if (!loaded) return;
    if (hasSeenTour(tourId)) return;

    const timer = setTimeout(() => {
      openGuide(tourId);
    }, delayMs);

    return () => clearTimeout(timer);
  }, [loaded, tourId]); // eslint-disable-line react-hooks/exhaustive-deps
}
